import { render } from "./BasicInfo.vue.js?vue&type=template&id=57a68ebf!=!../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./BasicInfo.vue?vue&type=template&id=57a68ebf"
import script from "./BasicInfo.vue.js?vue&type=script&lang=js!=!../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./BasicInfo.vue?vue&type=script&lang=js"
export * from "./BasicInfo.vue.js?vue&type=script&lang=js!=!../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./BasicInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__